import React from "react";
import BackgroundTitle from "../../components/ui/BackgroundTitle";
import Department from "../../components/ui/cards/Department";
import FAQ from "../../components/ui/FAQ";
import Doctor from "../../components/ui/cards/Doctor";

function Departments() {
  const firstData = [
    {
      que: "Tummy Tuck",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      que: "Liposuction",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      que: "Cosmetic Surgery",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
  ];

  const secondData = [
    {
      que: "Facial Reconstruciton",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      que: "Breast implants",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      que: "Ear Pinning",
      ans: "When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane. Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
  ];

  return (
    <>
      <div>
        <BackgroundTitle title='DEPARTMENTS' />
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        <div>
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-10 mb-9'>
            <div>
              <Department
                title='Dental Department'
                image={require("../../assets/departments/1.webp")}
              />
            </div>
            <div>
              <Department
                title='Surgical Department'
                image={require("../../assets/departments/2.webp")}
              />
            </div>
          </div>
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-10'>
            <div>
              <Department
                title='Neurological Department'
                image={require("../../assets/departments/3.webp")}
              />
            </div>
            <div>
              <Department
                title='Ophthalmological Department'
                image={require("../../assets/departments/4.webp")}
              />
            </div>
          </div>
        </div>
        <h1 className='uppercase text-center my-20 text-2xl sm:text-3xl text-gray-700'>
          LABORATORY TEST
        </h1>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-8'>
          <div>
            {firstData.map((data) => (
              <FAQ key={data.que} answer={data.ans} question={data.que} />
            ))}
          </div>
          <div>
            {secondData.map((data) => (
              <FAQ key={data.que} answer={data.ans} question={data.que} />
            ))}
          </div>
        </div>
        <div>
          <h1 className='uppercase text-center my-20 text-2xl sm:text-3xl text-gray-700'>
            OUR EXPERIENCED DOCTORS
          </h1>
          <div className='flex justify-center items-center'>
            <div>
              <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-10 sm:gap-14'>
                <Doctor
                  title='Dr. John Doe'
                  dic='Cardiologist'
                  pic={require("../../assets/doctors/1.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Neurologist'
                  pic={require("../../assets/doctors/2.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Pediatrician'
                  pic={require("../../assets/doctors/3.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Pulmonologist'
                  pic={require("../../assets/doctors/4.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Neurologist'
                  pic={require("../../assets/doctors/2.webp")}
                />
                <Doctor
                  title='Dr. John Doe'
                  dic='Cardiologist'
                  pic={require("../../assets/doctors/1.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Pulmonologist'
                  pic={require("../../assets/doctors/4.webp")}
                />
                <Doctor
                  title='Aldin Powell'
                  dic='Pediatrician'
                  pic={require("../../assets/doctors/3.webp")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Departments;
